import * as CAMPAIGN from './campaigns'

const Environment = {
  DEVELOPMENT: 'development',
  STAGING: 'staging',
  PRODUCTION: 'production',
}

export { Environment, CAMPAIGN }
